export { EventTracking, PlayerEvents } from './plugin';
export type { EventTrackingOptions } from './plugin';
